import { TextInput } from './text.mjs';
import { registerCustomElement } from '../utils.mjs';

export class DynamicCollectionInput extends TextInput {}

registerCustomElement('imt-input-dynamiccollection', DynamicCollectionInput);
